import sectionFreestyleHurryBoxCss from '../css-snippets/section-freestyle-hurry-box';

const html = `
<style>${sectionFreestyleHurryBoxCss}</style>
     <div data-attribute="content">
        <p><strong>🚨 Tired of trailer lights that fail, dim out, or cause wiring headaches?</strong></p>
        <p>Upgrade your trailer, truck, or boat with our 4" LED Trailer Tail Lights - the super bright, waterproof, and easy-to-install solution trusted by thousands of drivers!</p>
        <p>💡 Ultra-Bright LEDs - Brighter than factory lights for maximum visibility in all conditions</p>
        <p>💧 Waterproof &amp; Sealed - Withstands rain, splashes, and harsh road conditions</p>
        <p>🔧 Easy DIY Install - Fits standard brackets, clear wiring guide, no full rewiring needed</p>
        <p>💰 Cost-Saving Replacement - Fixes old or broken lights without buying extra parts</p>
        <p>🚛 Versatile Fit - Works with trailers, pickups, vans, boats, caravans &amp; more</p>
        <p>⏳ <span style="color:hsl(0, 75%, 60%);"><strong>Flash Sale</strong></span><strong>:</strong> 50% OFF</p>
    </div>
`;
export default html;
